import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

type Props = {
  vendorId: string;
};

const VendorDetailActions = ({ vendorId }: Props) => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <PageAudienceFilter />
      <ShareMenu
        notificationPageKey="vendor"
        notificationParams={{
          vendorIds: [vendorId],
          audienceIds: audience?.id,
        }}
      />
    </div>
  );
};

export default VendorDetailActions;
